import axios, { AxiosResponse, Canceler } from 'axios';
import { IDataQueryParams, IDataResponse, queryObjectToString, IDataUpdatePayload, ITagsResponse, ITestCollectionPayload, IAddCollectionPayload, ICollection, ICollectionQueryParams, ICollectionsResponse, IDeleteCollectionPayload, ICollectionDeleteResponse, IModelCollectionFetchApiQueryParams, IModelCollectionsResponse, IDeleteModelCollectionPayload, IModelCollectionDeleteResponse, IModelCollectionFetchBiggestVersionOutOfAllDocumentsQueryParams, GetDataSetCollectionUniqueNamesApiResponse, IStatus, IModelCollection, GetResourceFromDBByIdAPIReqPayload, IData, DataSetCollectionQueryParams, UpdateAllResourcesQueryParam, DeleteBulkResourcesQueryParam, ModelCollectionDeployApiRequestPayload, ITestCollectionRequestPayload, ITestCollectionFetchQueryParams, IDeleteTestCollectionPayload, ITestCollectionsResponse, ITestCollectionDeleteResponse, IBestModelCollectionPageQueryParams, IModelAnalyticsFetchAccuracyQueryParams, IModelAnalyticsFetchTestDatSetQueryParams, IModelAnalyticsFetchTrainDataSetQueryParams, IModelAnalyticsAccuracy, IModelAnalyticsTestDataSet, IModelAnalyticsTrainDataSetForEachModelVersion, IModelAnalyticsFetchTestStatisticalDataQueryParams, IModelAnalyticsTestStatisticalData, IModelCollectionToCompareFetchApiQueryParams, IModelCollectionsToCompare, IGetIntegrity, IGetAnalyticsResourcesQueryParams, IAnalyticsResourcesResponse, IDataSetModelCollectionDataBoostUpdate, IReTestingRequestPayload, IReTestApiResponse, IAnalyticsLabelConfidenceScoreQueryParams, ILabelConfidenceScoreResponse, IModelAnalyticsFetchTestDatSetForTestCollectionScenarioQueryParams, IGetPredictionValuesQuery, IResponseUniquePredictionValues, IDatasetCollectionPayload, IModelCollectionPayload, TrimmedAudio, TrimmedText, IUniqueNameCollectionQueryParams, IUniqueNameCollectionResponse, ICopyCollectionPayload, ICopyCollectionResponse, IDatasetCollectionPageNumberQueryWithDataSet, IDatasetCollectionPageNumberQueryWithModel, IDatasetCollectionPageNumberResponse, ITestCollectionUniqueDataPayload, UniqueTestCollectionVersionsApiResponse, UniqueTestCollectionStatusesApiResponse, UniqueTestCollectionModelsApiResponse, UniqueTestCollectionDataSetsApiResponse, IndividualClassAccuracyAPIRequestPayload, IAdditionalHandTrackingDataQueryParams, AdditionalHandTrackingDataApiResponse, ITestCollection } from '../common';
import { IUniqueLabelAndPrediction, IUniqueLabelAndPredictionResponse } from '../common';

import { API } from './API';
import { AddModelCollectionScenario } from '../features/admin/features/projects/features/models/features/model/features/collections/components/AddModelCollection';
import { copyByValue, isNullOrUndefined } from './variableHelperService';
import moment from 'moment-timezone';
import { AddResourcesFromAnalyticsToCollectionQueryParamsReqPayload } from '../features/admin/features/projects/features/models/features/model/features/collections/components/ModelAnalyticsResources';
import { ModelCollectionHistoryData } from '../features/admin/features/projects/features/models/features/model/features/collections/types/ModelCollectionHistoryData.type';
import { ModelAnalyticsIndividualClassAccuracyApiResponseData } from '../common/constants/interfaces/modelAnalyticsIndividualClassAccuracyApiResponse';
import { Cache } from '../classes/Cache';
import { TEMP_APP_API } from './constants';

const CancelToken = axios.CancelToken;
let cancelGetResourceConfidenceScoresApi: Canceler;

const cache = new Cache()

const URL_STRINGS = {
    RESOURCE: 'resource',
    DOWNLOAD_DATA: 'csv/download',
    GET_TAGS: 'resource/tags',
    DATASET_COLLECTION: `collection/dataSet`,
    MODEL_COLLECTION: `collection/model`,
    TEST_COLLECTION: `collection/test`,
    MODEL_ANALYTICS: `collection/model/modelAnalytics`
}

export type IModelCollectionCheckpointFileDataReqPayloadForAddModelCollectionScenario = {
    description: string;
    name: string;
    isDefaultCheckpoint: boolean;
    files: {
        models: {
            description: string,
            name: string[],
        },
        additionalFiles: {
          name: string[],
          description: string
        }[]
    }
  }

export interface IModelCollectionPostReqPayload {
    parentCheckpointFile: File | null,
    childCheckpointFilesForModel: File[] | null,
    childCheckpointFilesForAdditionalFiles: File[] | null,
    model: string,
    modelDescription: string,
    hyperParameter: string,
    trainingDataDirectory: string[],
    modelArchitecture: string,
    startCheckpoint: string,
    version: string,
    status: IStatus,
    tags:string[]
    // Applicable only for reTrain scenario
    numberOfLayersToFreeze?: number,

    // files: {
    //     name: string,
    //     description: string
    // }[];
    parentCheckpointFileData: IModelCollectionCheckpointFileDataReqPayloadForAddModelCollectionScenario | null
    scenario: AddModelCollectionScenario,
    defaultDataSetCollectionId?: string
}

export type AddResourceToDataSetCollectionAPIRequestPayload = {
    dataSetCollectionIds: string[];
    resourceIds?: string[];
    addToDataSetCollectionQueryParams?: DataSetCollectionQueryParams;
};

export type AddResourcesFromAnalyticsFileToDataSetCollectionAPIRequestPayload = {
    dataSetCollectionIds: string[];
    addToDataSetCollectionQueryParams: AddResourcesFromAnalyticsToCollectionQueryParamsReqPayload;
};

export type AddResourceToDataSetCollectionAPIResponse = null;

type getDataApiConfigType = {
    onGettingCancelApiFunction?: (cancelApiFunction: Canceler)=>void
}

type getModelCollectionApiConfigType = {
    onGettingCancelModelCollectionApiFunction?: (cancelApiFunction: Canceler)=>void
    onGettingCancelLiveModelCollectionApiFunction?: (cancelApiFunction: Canceler) => void
}

type getTestCollectionApiConfigType = {
    onGettingCancelTestCollectionApiFunction?: (cancelApiFunction: Canceler)=>void
}
class DataService extends API {

    
    getData(data: IDataQueryParams, config: getDataApiConfigType = {}): Promise<AxiosResponse<IDataResponse>> {
        if (data.resourceStatusLastModifiedDateMinValue) {
            data.resourceStatusLastModifiedDateMinValue = new Date(data.resourceStatusLastModifiedDateMinValue).toISOString();
        }
        if (data.resourceStatusLastModifiedDateMaxValue) {
            data.resourceStatusLastModifiedDateMaxValue = new Date(data.resourceStatusLastModifiedDateMaxValue).toISOString();
        }

        /** converting local time to EST time */
        if (data.forecastDateMinValue) {
            data.forecastDateMinValue = moment.tz(data.forecastDateMinValue, "America/New_York").toISOString();
        }
        if (data.forecastDateMaxValue) {
            data.forecastDateMaxValue = moment.tz(data.forecastDateMaxValue, "America/New_York").toISOString();
        }
        /** converting local time to EST time ends */

        const queryParamsWithBase64Encoding: Array<keyof(IDataQueryParams)> = []
        if(data.nameRegex) queryParamsWithBase64Encoding.push('nameRegex')
        if(data.tagRegex) queryParamsWithBase64Encoding.push('tagRegex')
        if(data.labelRegex) queryParamsWithBase64Encoding.push('labelRegex')
        if(data.promptRegex) queryParamsWithBase64Encoding.push('promptRegex')
        if(data.predictionRegex) queryParamsWithBase64Encoding.push('predictionRegex')

        return this.api.get(
            `${URL_STRINGS.RESOURCE}?${queryObjectToString(data, queryParamsWithBase64Encoding)}`,
            {
                                                cancelToken: new CancelToken(function executor(c) {
                    if (config?.onGettingCancelApiFunction) {
                        config.onGettingCancelApiFunction(c)
                    }
                        })
            }
        );
    }

    updateData(body: IDataUpdatePayload | UpdateAllResourcesQueryParam | DeleteBulkResourcesQueryParam): Promise<AxiosResponse<unknown>> {
        return this.api.put(`${URL_STRINGS.RESOURCE}`, body);
    }
   updateMultipleImageAnnotationData(body:IDataUpdatePayload):Promise<AxiosResponse<unknown>>{
    return this.api.put(`${URL_STRINGS.RESOURCE}/updateMultipleImageAnnotation`, body);
   }
    createResource(formData: FormData): Promise<IData> {
        return this.api.post(`${URL_STRINGS.RESOURCE}`, formData, {
            headers: {'Content-Type': 'multipart/form-data'}
        })
    }

    addResourceInModel(body: FormData): Promise<AxiosResponse<unknown>> {
        return this.api.post(URL_STRINGS.RESOURCE, body);
    }

    updateOriginalImageResource(body: FormData): Promise<AxiosResponse<unknown>>{
        return this.api.put(`${URL_STRINGS.RESOURCE}/updateOriginalImageResource`, body);
    }

    uploadResourceToGCS(data: {resourceFileSignedUrlForUpload: string, resourceContentType: string, resource: any}): any {
        // const options = {
        //     url: data.resourceFileSignedUrlForUpload,
        //     method: 'PUT',
        //     headers: {
        //         'Content-Type': data.resourceContentType,
        //         'Access-Control-Allow-Origin': '*',
        //     },
        //     data: data.resource,
        //     maxContentLength: Infinity,
        //     maxBodyLength: Infinity,
        // };
        // console.log(options);
        // // @ts-ignore
        // return axios(options);

        return this.api.put(data.resourceFileSignedUrlForUpload, {data: data.resource}, {
            headers: {'Content-Type': data.resourceContentType, 'Content-Length': Infinity, 'content-length': Infinity}
        })
    }

    getResourceFromDBById(reqPayload: GetResourceFromDBByIdAPIReqPayload): Promise<AxiosResponse<IData>> {
        const reqPayloadWithoutResourceId = copyByValue(reqPayload);

        // @ts-ignore
        delete reqPayloadWithoutResourceId?.resourceId;

        return this.api.get(`${URL_STRINGS.RESOURCE}/${reqPayload.resourceId}?${queryObjectToString(reqPayloadWithoutResourceId)}`,{withCredentials:true});
    }

    deleteData(body: IDataUpdatePayload | UpdateAllResourcesQueryParam | DeleteBulkResourcesQueryParam, model_type: string): Promise<AxiosResponse<unknown>> {
        return this.api.delete(`${URL_STRINGS.RESOURCE}`, { data: body });
    }

    // downloadData(body: IDownlaodData): Promise<AxiosResponse<IDownlaodDataResponse>> {
    //     return this.api.post(URL_STRINGS.DOWNLOAD_DATA, body);
    // }

    getTags(modelId: string, status?: string, value?: string, limit?: number): Promise<AxiosResponse<ITagsResponse>> {
        return this.api.get(`${URL_STRINGS.GET_TAGS}?modelId=${modelId}${status ? `&status=${status}` : ""}${value ? `&value=${value}` : ""}${limit ? `&limit=${limit}` : ""}`);
    }

    addCollection(body: IAddCollectionPayload): Promise<AxiosResponse<ICollection>> {
        return this.api.post(`${URL_STRINGS.DATASET_COLLECTION}`, body);
    }

    async getDataSetCollectionUniqueNameIfAlreadySameNameExistInModel(body: {
        modelId: string,
        datasetCollectionName: string
    }): Promise<string> {
        const apiResponse = await this.api.get(`${URL_STRINGS.DATASET_COLLECTION}/uniqueNameIfAlreadySameNameExistInModel?${queryObjectToString(body)}`);
        return apiResponse.data;
    }

    /**
     * To update a dataset collection
     * @param body contains specific dataset collection and the field value that needs to be updated
     * @returns API response
     */
    updateDatasetCollection(body: IDatasetCollectionPayload): Promise<AxiosResponse<any>> {
        return this.api.put(`${URL_STRINGS.DATASET_COLLECTION}`, body)
    }

    /**
     * To update the model Collection
     * @param body contains specific model id and the field value that needs to be updated
     * @returns API response
     */
    updateModelCollection(body: IModelCollectionPayload): Promise<AxiosResponse<any>>{
        return this.api.put(`${URL_STRINGS.MODEL_COLLECTION}`, body)
    }

    /**
     * To update the test Collection
     * @param body contains specific model id and the field value that needs to be updated
     * @returns API response
     */
    updateTestCollection(body: ITestCollectionPayload): Promise<AxiosResponse<any>>{
        return this.api.put(`${URL_STRINGS.TEST_COLLECTION}`, body)
    }

    deleteCollection(body: IDeleteCollectionPayload): Promise<AxiosResponse<ICollectionDeleteResponse>> {
        return this.api.delete(`${URL_STRINGS.DATASET_COLLECTION}`, {data: body});
    }

    deleteModelCollections(body: IDeleteModelCollectionPayload): Promise<AxiosResponse<IModelCollectionDeleteResponse>> {
        return this.api.delete(`${URL_STRINGS.MODEL_COLLECTION}`, {data: body});
    }

    deleteTestCollections(body: IDeleteTestCollectionPayload): Promise<AxiosResponse<ITestCollectionDeleteResponse>> {
        return this.api.delete(`${URL_STRINGS.TEST_COLLECTION}`, {data: body})
    }

    getCollections(data: ICollectionQueryParams): Promise<AxiosResponse<ICollectionsResponse>> {
        if (data.collectionCreatedDateMaxValue) {
            data.collectionCreatedDateMaxValue = new Date(data.collectionCreatedDateMaxValue).toISOString();
        }
        if (data.collectionCreatedDateMinValue) {
            data.collectionCreatedDateMinValue = new Date(data.collectionCreatedDateMinValue).toISOString();
        }
        return this.api.get(`${URL_STRINGS.DATASET_COLLECTION}?${queryObjectToString(data)}`);
    }
    
    getDataSetCollectionUniqueNames(data: {modelId: string}): Promise<AxiosResponse<GetDataSetCollectionUniqueNamesApiResponse>> {
        return this.api.get(`${URL_STRINGS.DATASET_COLLECTION}/${data.modelId}/uniqueCollectionNames`);
    }

    async updateResourceTxtFileContents(resourceId: string, txtFileContent: string): Promise<{fileURL: string}> {
        const reqBody = {
            txtFileContent
        }
        const apiResponse = await this.api.put(`${URL_STRINGS.RESOURCE}/${resourceId}/updateResourceTxtFileContents`, reqBody);
        return apiResponse.data
    }

    performAiAssistanceOnResource(resourceId: string): Promise<AxiosResponse<{updatedResource: IData}>> {
        return this.api.put(`${URL_STRINGS.RESOURCE}/${resourceId}/aiAssistant`)
    }

    performAnalyticsAiAssistanceOnResource(resourceId: string, additionalData?: {referenceResourceId?: string, annotations?: string}): Promise<AxiosResponse<{updatedResource: IData}>> {
        return this.api.put(`${URL_STRINGS.RESOURCE}/${resourceId}/analyticsAiAssistant`, additionalData)
    }


    addModelCollectionApi(data: IModelCollectionPostReqPayload): Promise<AxiosResponse<void>> {

        const bodyFormData = new FormData();
        for (let jsonKeyIndex = 0; jsonKeyIndex < Object.keys(data).length; jsonKeyIndex++) {
            const jsonKey: string = Object.keys(data)[jsonKeyIndex];
            // @ts-ignore
            const jsonKeyValue: any = data[jsonKey] as any;
            if(jsonKey === "tags"){
                bodyFormData.append(jsonKey,JSON.stringify(jsonKeyValue))
            }
            else if (jsonKey === 'parentCheckpointFile') {
                if (jsonKeyValue) {
                    bodyFormData.append(jsonKey, jsonKeyValue);
                }
            } else if (jsonKey === "childCheckpointFilesForModel" || jsonKey === "childCheckpointFilesForAdditionalFiles") {
                if (
                    jsonKeyValue &&
                    jsonKeyValue.length>0
                ) {
                    for (let index = 0; index < jsonKeyValue.length; index++) {
                        const arrayElement = jsonKeyValue[index];
                        bodyFormData.append(jsonKey, arrayElement);
                    } 
                }
            } else if (jsonKey === 'parentCheckpointFileData') {
                bodyFormData.append('parentCheckpointFileData', JSON.stringify(jsonKeyValue))
            } else if (Array.isArray(jsonKeyValue)) {
                for (let index = 0; index < jsonKeyValue.length; index++) {
                    const arrayElement = jsonKeyValue[index];
                    bodyFormData.append(jsonKey, arrayElement);
                }
            } else {
                bodyFormData.append(jsonKey, jsonKeyValue);
            }

        }
        return this.api.post(`${URL_STRINGS.MODEL_COLLECTION}`, bodyFormData, {headers: {'Content-Type': 'multipart/form-data'}});
    }

    fetchModelCollectionsFromDB(queryParams: IModelCollectionFetchApiQueryParams, config: getModelCollectionApiConfigType = {}): Promise<AxiosResponse<IModelCollectionsResponse>> {
        return this.api.get(`${URL_STRINGS.MODEL_COLLECTION}?${queryObjectToString(queryParams)}`,
        {
            cancelToken: new CancelToken(function executor(c) {
                if (config?.onGettingCancelLiveModelCollectionApiFunction) {
                    config.onGettingCancelLiveModelCollectionApiFunction(c)
                }
                if(config?.onGettingCancelModelCollectionApiFunction) {
                    config.onGettingCancelModelCollectionApiFunction(c)
                }
            })
        })
    }

    getModelCollectionByIdFromDB(_id: string) {
        return this.api.get<{
            modelCollection: IModelCollection
        }>(`${URL_STRINGS.MODEL_COLLECTION}/byId?_id=${_id}`);
    }

    fetchModelCollectionsToCompareFromDB(queryParams: IModelCollectionToCompareFetchApiQueryParams): Promise<AxiosResponse<IModelCollectionsToCompare[]>> {
        return this.api.get(`${URL_STRINGS.MODEL_ANALYTICS}/modelCollectionsAllowedToCompare?${queryObjectToString(queryParams)}`)
    }
    getAdditionalHandTrackingData(
        queryParams: IAdditionalHandTrackingDataQueryParams
      ): Promise<AxiosResponse<AdditionalHandTrackingDataApiResponse>> {
        const apiUrl = `${URL_STRINGS.MODEL_ANALYTICS}/getModelCollectionHandsStatistics`;
         const urlWithParams = `${apiUrl}?modelId=${queryParams.modelId}&modelCollectionIds=${JSON.stringify(queryParams.modelCollectionIds)}`;
         return  this.api.get(urlWithParams);
    
      }

    getModelCollectionWithUnseenTrainedNotification(queryParams: string): Promise<AxiosResponse<IModelCollection>> {
        const apiUrl = `${URL_STRINGS.MODEL_COLLECTION}/collectionWithUnseenTrainedNotification`;
        const urlWithParams = `${apiUrl}?userEmail=${queryParams}`;
        return this.api.get(urlWithParams)
    }
    
    fetchTestCollectionsFromDB(queryParam: ITestCollectionFetchQueryParams, config : getTestCollectionApiConfigType = {}): Promise<AxiosResponse<ITestCollectionsResponse>> {
        return this.api.get(`${URL_STRINGS.TEST_COLLECTION}?${queryObjectToString(queryParam)}`,
        {
            cancelToken: new CancelToken(function executor(c) {
                if (config?.onGettingCancelTestCollectionApiFunction) {
                    config.onGettingCancelTestCollectionApiFunction(c)
                }
            })
        })
    }

    getUniqueTestCollectionVersions(
        data: ITestCollectionUniqueDataPayload
      ): Promise<AxiosResponse<UniqueTestCollectionVersionsApiResponse>> {
        return this.api.get(
          `${URL_STRINGS.TEST_COLLECTION}/model/${data.modelId}/uniqueTestCollectionVersions`
        );
    }

    getUniqueTestCollectionStatuses(
        data: ITestCollectionUniqueDataPayload
      ): Promise<AxiosResponse<UniqueTestCollectionStatusesApiResponse>> {
        return this.api.get(
          `${URL_STRINGS.TEST_COLLECTION}/model/${data.modelId}/uniqueTestCollectionStatuses`
        );
    }

    getUniqueTestCollectionModels(
        data: ITestCollectionUniqueDataPayload
      ): Promise<AxiosResponse<UniqueTestCollectionModelsApiResponse>> {
        return this.api.get(
          `${URL_STRINGS.TEST_COLLECTION}/model/${data.modelId}/uniqueModelCollections`
        );
    }

    getUniqueTestCollectionDataSets(
        data: ITestCollectionUniqueDataPayload
      ): Promise<AxiosResponse<UniqueTestCollectionDataSetsApiResponse>> {
        return this.api.get(
          `${URL_STRINGS.TEST_COLLECTION}/model/${data.modelId}/uniqueTestCollectionDatasets`
        );
    }

    getModelAnanlyticsAccuracy(queryParam: IModelAnalyticsFetchAccuracyQueryParams): Promise<AxiosResponse<IModelAnalyticsAccuracy[]>> {
        return this.api.get(`${URL_STRINGS.MODEL_ANALYTICS}/accuracies?${queryObjectToString(queryParam)}`)
    }

    getModelAnanlyticsTestDataSet(queryParam: IModelAnalyticsFetchTestDatSetQueryParams): Promise<AxiosResponse<IModelAnalyticsTestDataSet[]>> {
        return this.api.get(`${URL_STRINGS.MODEL_ANALYTICS}/testDataSets/?${queryObjectToString(queryParam)}`)
    }

    getModelAnanlyticsTestDataSetForTestCollectionScenario(queryParam: IModelAnalyticsFetchTestDatSetForTestCollectionScenarioQueryParams): Promise<AxiosResponse<IModelAnalyticsTestDataSet[]>> {
        return this.api.get(`${URL_STRINGS.MODEL_ANALYTICS}/testDataSets/?${queryObjectToString(queryParam)}`)
    }

    getModelAnanlyticsTrainDataSet(queryParam: IModelAnalyticsFetchTrainDataSetQueryParams): Promise<AxiosResponse<IModelAnalyticsTrainDataSetForEachModelVersion[]>> {
        return this.api.get(`${URL_STRINGS.MODEL_ANALYTICS}/trainDataSets/?${queryObjectToString(queryParam)}`)
    }

    async getModelAnalyticsTestStatisticalData(queryParam: IModelAnalyticsFetchTestStatisticalDataQueryParams, doCacheApiResponse?: boolean): Promise<AxiosResponse<IModelAnalyticsTestStatisticalData[]>> {
        if (TEMP_APP_API) {
            // Use a separate Axios instance with TEMP_APP_API
            const integrityApi = axios.create({
                baseURL: TEMP_APP_API,
                headers: {
                    'Content-type': 'application/json; charset=utf-8',
                },
                withCredentials: true,
            });

            return integrityApi.get(`${URL_STRINGS.MODEL_ANALYTICS}/getTestStatisticalData?${queryObjectToString(queryParam)}`)
        } else {
            // Use the existing API instance with the default base URL
            return this.api.get(`${URL_STRINGS.MODEL_ANALYTICS}/getTestStatisticalData?${queryObjectToString(queryParam)}`)
        }
        // const requestURL = `${URL_STRINGS.MODEL_ANALYTICS}/getTestStatisticalData?${queryObjectToString(queryParam)}`;

        // if(doCacheApiResponse===false) {
        //     const axiosResponse = await this.api.get(requestURL)
        //     return axiosResponse;
        // }
        // else if (!cache.get(requestURL)) {
        //     const axiosResponse = await this.api.get(requestURL)

        //     cache.set(requestURL, JSON.stringify(axiosResponse || {}), 60000)
        //     return axiosResponse;
        // } else {
        //     return JSON.parse(cache.get(requestURL))
        // }
        // return this.api.get(requestURL)
        
    }

    setDataSetCollectionDataBoost(data: IDataSetModelCollectionDataBoostUpdate): Promise<AxiosResponse<unknown>> {
        return this.api.put(`${URL_STRINGS.DATASET_COLLECTION}`, data)
    }
    // getModelAnanlyticsIntegrity(queryParam: IModelAnalyticsFetchIntegrityQueryParams): Promise<AxiosResponse<IModelAnalyticsIntegrity[]>> {
    //     return this.api.get(`${URL_STRINGS.MODEL_ANALYTICS}/integrity?${queryObjectToString(queryParam)}`)
    // }

    // getModelAnanlyticsTopPerformingModel(queryParam: IModelAnalyticsFetchTopPerformingModelQueryParams): Promise<AxiosResponse<IModelAnalyticsTopPerformingModelResponse>> {
    //     return this.api.get(`${URL_STRINGS.MODEL_ANALYTICS}/topPerformingModel?${queryObjectToString(queryParam)}`)
    // }
    // readModelCollectionFieldsDataViaFile(file: File): Promise<AxiosResponse<IReadModelCollectionFieldsDataViaFileApiResponse>> {
    //     const bodyFormData = new FormData();
    //     bodyFormData.append('fieldDataFile', file);
    //     return this.api.post(`${URL_STRINGS.MODEL_COLLECTION}/readFieldsData`, bodyFormData, {headers: {'Content-Type': 'multipart/form-data'}})
    // }
    getBiggestVersionOutOfAllModelCollectionsFromDB(data: IModelCollectionFetchBiggestVersionOutOfAllDocumentsQueryParams): Promise<AxiosResponse<string>> {
        return this.api.get(`${URL_STRINGS.MODEL_COLLECTION}/biggestVersion?modelId=${data.modelId}&modelArchitecture=${data.modelArchitecture}`);
    }
    getModelCollectionsHavingDefaultCheckpoints(data: {modelId: string}): Promise<AxiosResponse<IModelCollection[]>> {
        return this.api.get(`${URL_STRINGS.MODEL_COLLECTION}/modelCollectionsHavingDefaultCheckpoints?modelId=${data.modelId}`);
    }

    getBiggestVersionOutOfAllTestCollectionsFromDB(modelId: string): Promise<AxiosResponse<string>> {
        return this.api.get(`${URL_STRINGS.TEST_COLLECTION}/biggestVersion?modelId=${modelId}`);
    }

    getModelCollectionsHavingFiles(data: { modelId: string }): Promise<AxiosResponse<IModelCollection[]>> {
        return this.api.get(`${URL_STRINGS.MODEL_COLLECTION}/havingFiles?modelId=${data.modelId}`);
    }
    
    addResourceToDataSetCollection(data: AddResourceToDataSetCollectionAPIRequestPayload): Promise<AxiosResponse<AddResourceToDataSetCollectionAPIResponse>> {
        if (data.addToDataSetCollectionQueryParams) {
            data = {
              ...data,
              addToDataSetCollectionQueryParams: {
                ...data.addToDataSetCollectionQueryParams,
                resourceStatusLastModifiedDateMaxValue: data.addToDataSetCollectionQueryParams.resourceStatusLastModifiedDateMaxValue ? new Date( data.addToDataSetCollectionQueryParams.resourceStatusLastModifiedDateMaxValue ).toISOString() : data.addToDataSetCollectionQueryParams.resourceStatusLastModifiedDateMaxValue as string,
                resourceStatusLastModifiedDateMinValue: data.addToDataSetCollectionQueryParams.resourceStatusLastModifiedDateMinValue ? new Date( data.addToDataSetCollectionQueryParams.resourceStatusLastModifiedDateMinValue ).toISOString() : data.addToDataSetCollectionQueryParams.resourceStatusLastModifiedDateMinValue as string,
                forecastDateMinValue: data.addToDataSetCollectionQueryParams.forecastDateMinValue ? moment.tz(data.addToDataSetCollectionQueryParams.forecastDateMinValue, "America/New_York").toISOString() : data.addToDataSetCollectionQueryParams.forecastDateMinValue as string,
                forecastDateMaxValue: data.addToDataSetCollectionQueryParams.forecastDateMaxValue ? moment.tz(data.addToDataSetCollectionQueryParams.forecastDateMaxValue, "America/New_York").toISOString() : data.addToDataSetCollectionQueryParams.forecastDateMaxValue as string,
              },
            };
        }
        return this.api.put(`${URL_STRINGS.DATASET_COLLECTION}/addResource`, data);
    }

    addResourcesFromAnalyticsFileToDataSetCollection(data: AddResourcesFromAnalyticsFileToDataSetCollectionAPIRequestPayload): Promise<AxiosResponse<null>> {
        return this.api.put(`${URL_STRINGS.MODEL_ANALYTICS}/addResource`, data);
    }

    getModelCollectionFileUrlFromDB(reqPayload: {modelCollectionId: string, fileId: string}): Promise<AxiosResponse<string>> {
        return this.api.get(`${URL_STRINGS.MODEL_COLLECTION}/files/downloadUrl?${queryObjectToString(reqPayload)}`);
    }

    updateResourceDataSetCollections(data: {dataSetCollectionIds: string[], resourceId: string}): Promise<AxiosResponse<void>> {
        const requestBody = {
            dataSetCollectionIds: data.dataSetCollectionIds
        }
        return this.api.put(`${URL_STRINGS.RESOURCE}/${data.resourceId}/dataSetCollections`, requestBody);
    }

    getDownloadURLForDataSetCollectionResourcesFile(data: {dataSetCollectionId: string}): Promise<AxiosResponse<string>> {
        return this.api.get(`${URL_STRINGS.DATASET_COLLECTION}/${data.dataSetCollectionId}/resourcesFile/downloadURL`, {})
    }

    callModelCollectionDeployApi(data: ModelCollectionDeployApiRequestPayload): Promise<AxiosResponse<void>> {
        return this.api.post(`${URL_STRINGS.MODEL_COLLECTION}/deployment`, data);
    }

    addTestCollection(data: ITestCollectionRequestPayload): Promise<AxiosResponse<any>> {
        return this.api.post(`${URL_STRINGS.TEST_COLLECTION}`, data)
    }
    getPageNumberOfBestModel(data: IBestModelCollectionPageQueryParams): Promise<AxiosResponse<number>> {
        return this.api.get(`${URL_STRINGS.MODEL_COLLECTION}/pageHavingBestModal?${queryObjectToString(data)}`)
    }
    getAnalyticsResourceData(data: IGetAnalyticsResourcesQueryParams): Promise<AxiosResponse<IAnalyticsResourcesResponse>> {

      return this.api.get(`${URL_STRINGS.MODEL_COLLECTION}/modelAnalytics/getResources?${queryObjectToString(data)}`)
    }
    async getIntegrity(data: IGetIntegrity, doCacheApiResponse?: boolean){
        if (TEMP_APP_API) {
            // Use a separate Axios instance with TEMP_APP_API
            const integrityApi = axios.create({
                baseURL: TEMP_APP_API,
                headers: {
                    'Content-type': 'application/json; charset=utf-8',
                },
                withCredentials: true,
            });

            return integrityApi.get(`${URL_STRINGS.MODEL_COLLECTION}/modelAnalytics/integrity?${queryObjectToString(data)}`);
        } else {
            // Use the existing API instance with the default base URL
            return this.api.get(`${URL_STRINGS.MODEL_COLLECTION}/modelAnalytics/integrity?${queryObjectToString(data)}`);
        }


        // const requestURL = `${URL_STRINGS.MODEL_COLLECTION}/modelAnalytics/integrity?${queryObjectToString(data)}`;

        // if(doCacheApiResponse===false) {
        //     const axiosResponse = await this.api.get(requestURL)
        //     return axiosResponse;
        // }
        // else if (!cache.get(requestURL)) {
        //     const axiosResponse = await this.api.get(requestURL)

        //     cache.set(requestURL, JSON.stringify(axiosResponse || {}), 60000)
        //     return axiosResponse;
        // } else {
        //     return JSON.parse(cache.get(requestURL))
        // }        
        
        // return this.api.get(requestURL)
    }
    getIndividualClassAccuracy(data: IndividualClassAccuracyAPIRequestPayload): Promise<AxiosResponse<ModelAnalyticsIndividualClassAccuracyApiResponseData>>{
        // @ts-ignore
        // return Promise.resolve({
        //     data: [
        //         {
        //             "_id": "65396eb9d185d9f0d69d36c5",
        //             "version": "1.39.37",
        //             "created_at": "2023-10-25T19:39:14.964Z",
        //             "classes": [
        //                 {
        //                     "class": "sizzli",
        //                     "goodConfidenceScore": 44,
        //                     "totalTestDataSets": 8,
        //                     "noOfTrainingDataPoints": 105,
        //                     "IntegrityAccuracy": 77
        //                 }
        //             ],
        //             "status": "Trained",
        //             "accuracy": {
        //                 "value": 97.82012473843528,
        //                 "type": "noLiveExists"
        //             },
        //             "totalDataSetsCount": 90356
        //         }
        //     ]
        // })
        
        if (data?.modelCollectionsAdditionalData) {
            // @ts-ignore
            data.modelCollectionsAdditionalData = JSON.stringify(data.modelCollectionsAdditionalData);
        }
        return this.api.get(`${URL_STRINGS.MODEL_ANALYTICS}/IndividualClassAccuracy?${queryObjectToString(data)}`)
    }

    getUniquePredictionValues(body: IGetPredictionValuesQuery): Promise<AxiosResponse<IResponseUniquePredictionValues>> {
        return this.api.get(`${URL_STRINGS.MODEL_ANALYTICS}/resources/uniquePredictionValues?${queryObjectToString(body)}`)
    }

    getModelCollectionTrainingDataSetNameIfMoreThanOneTrainingDataSets(data: {modelCollectionVersion: string, modelId: string}): Promise<AxiosResponse<string>> {
        return this.api.get(`${URL_STRINGS.MODEL_COLLECTION}/modelCollectionTrainingDataSetNameIfMoreThanOneTrainingDataSets?${queryObjectToString(data)}`)
    }

    getResourceLabelsAndCountForCollection(id: string): Promise<AxiosResponse<{[key: string]: number}>> {
        return this.api.get(`${URL_STRINGS.DATASET_COLLECTION}/labels/${id}`)
    }

    getDatasetCollectionPageNumber(data: IDatasetCollectionPageNumberQueryWithDataSet | IDatasetCollectionPageNumberQueryWithModel): Promise<AxiosResponse<IDatasetCollectionPageNumberResponse>> {
        return this.api.get(`${URL_STRINGS.DATASET_COLLECTION}/pageNumberInDataSetCollectionTable?${queryObjectToString(data)}`)
    }

    async getModelCollectionPageNumberInModelCollectionsTable(data: {
        modelCollectionId: string,
        sortField: "created_at",
        sortOrder: 'descending' | 'ascending',
        modelId: string,
        pageRowsLimit: string
    }): Promise<{
        pageNumber: number,
        modelCollectionId: string
    }> {
        const apiResponse = await this.api.get(`${URL_STRINGS.MODEL_COLLECTION}/pageNumberInModelCollectionTable?${queryObjectToString(data)}`)
        return apiResponse.data;
    }

    getModelCollectionParentCheckpointFileDetails(
        data: {
            parentCheckpointFileId: string,
            getModelCollectionVersionOfParentCheckpointFile?: "true",
            getParentCheckpointFileName?: "true",
            getParentCheckpointFileGCSName?: "true"
        }
    )
        : Promise<AxiosResponse<ModelCollectionParentCheckpointFileDetailsApiResponse>> 
    {
        return this.api.get(`${URL_STRINGS.MODEL_COLLECTION}/parentCheckpointFileDetails?${queryObjectToString(data)}`)
    }

    modelCollectionReTest(body: IReTestingRequestPayload): Promise<AxiosResponse<IReTestApiResponse>> {
        return this.api.post(`${URL_STRINGS.MODEL_COLLECTION}/reTest`, body);
    }
    getLabelConfidenceScore(data: IAnalyticsLabelConfidenceScoreQueryParams): Promise<AxiosResponse<ILabelConfidenceScoreResponse>> {
        return this.api.get(`${URL_STRINGS.MODEL_ANALYTICS}/labelConfidenceScores?${queryObjectToString(data)}`)
    }

    createAndSaveTrimmedAudioInDB(requestPayload: {
        resourceId: string,
        startTimeInSeconds: TrimmedAudio["startTimeInSeconds"],
        endTimeInSeconds: TrimmedAudio["endTimeInSeconds"],
        label: TrimmedAudio["label"],
    }): Promise<AxiosResponse<TrimmedAudio>> {
        return this.api.post(`${URL_STRINGS.RESOURCE}/trimmedAudio`, requestPayload)
    }

    createAndSaveTrimmedTextInDB(requestPayload: {
        trimmedTextId: string,
        resourceId: string,
        startPosition: TrimmedText["startPosition"],
        endPosition: TrimmedText["endPosition"],
        label: TrimmedText["label"],
        isPiiData?: TrimmedText["isPiiData"]  
    }): Promise<AxiosResponse<TrimmedText>> {
        return this.api.post(`${URL_STRINGS.RESOURCE}/trimmedText`, requestPayload)
    }

    updateTrimmedAudioInDB(requestPayload: {
        trimmedAudioId: string,
        startTimeInSeconds?: TrimmedAudio["startTimeInSeconds"],
        endTimeInSeconds?: TrimmedAudio["endTimeInSeconds"],
        label?: TrimmedAudio["label"]        
    }): Promise<AxiosResponse<void>> {
        return this.api.put(`${URL_STRINGS.RESOURCE}/trimmedAudio`, requestPayload) 
    }

    updateTrimmedTextInDB(requestPayload: {
        trimmedTextId: string,
        startPosition?: TrimmedText["startPosition"],
        endPosition?: TrimmedText["endPosition"],
        label?: TrimmedText["label"],
        isPiiData ?: TrimmedText["isPiiData"],
        tag ?: TrimmedText["tag"],        
    }): Promise<AxiosResponse<void>> {
        return this.api.put(`${URL_STRINGS.RESOURCE}/trimmedText`, requestPayload) 
    }

    checkDatasetCollectionNameUniqueness(data: IUniqueNameCollectionQueryParams): Promise<AxiosResponse<IUniqueNameCollectionResponse>> {
        return this.api.get(`${URL_STRINGS.DATASET_COLLECTION}/checkDatasetCollectionNameExist?${queryObjectToString(data)}`)
    }

    copyCollectionToAnotherCollection(body: ICopyCollectionPayload): Promise<AxiosResponse<ICopyCollectionResponse>> {
        return this.api.post(`/dataSetCopyingToAnotherModelProcess`, body)
    }

    deleteTrimmedAudioInDB(requestPayload: {
        trimmedAudioId: string,
    }): Promise<AxiosResponse<void>> {
        return this.api.delete(`${URL_STRINGS.RESOURCE}/trimmedAudio?trimmedAudioId=${requestPayload.trimmedAudioId}`) 
    }

    deleteTrimmedTextInDB(requestPayload: {
        trimmedTextId: string,
    }): Promise<AxiosResponse<void>> {
        return this.api.delete(`${URL_STRINGS.RESOURCE}/trimmedText?trimmedTextID=${requestPayload.trimmedTextId}`) 
    }
    
    getUniqueLabelsAndPredictions(data: IUniqueLabelAndPrediction): Promise<AxiosResponse<IUniqueLabelAndPredictionResponse>> {
        return this.api.get(`${URL_STRINGS.RESOURCE}/uniqueLabelsAndPredictions?${queryObjectToString(data)}`);
    }

    aiTestForModelCollection(body: {datasetCollectionId : string}): Promise<AxiosResponse<void>> {
        return this.api.post(`${URL_STRINGS.DATASET_COLLECTION}/${body.datasetCollectionId}/aiTest`);
    }

    getResourceConfidenceScores(
        reqBody: {
            modelId: string;
            modelCollectionId: string;
            resourceIds: string[];

            /**
             * only for test collection analysis scenario
             */
            testCollectionId: string; 
        }
    ): Promise<AxiosResponse<{resources: {_id: string; confidenceScore: string; predicted: string; modelVersion: string; modelCollectionId: string}[]}>> {
        if (cancelGetResourceConfidenceScoresApi) {
            cancelGetResourceConfidenceScoresApi();
        }
        return this.api.get(
            `${URL_STRINGS.MODEL_ANALYTICS}/resourceConfidenceScores?${queryObjectToString(reqBody)}`,
            {
                cancelToken: new CancelToken(function executor(c) {
                    cancelGetResourceConfidenceScoresApi = c
                })
            }
        )        
    }
    getResourceConfidenceScoresWithoutCancelMechanism(
        reqBody: {
            modelId: string;
            modelCollectionId: string;
            resourceIds: string[];

            /**
             * only for test collection analysis scenario
             */
            testCollectionId: string; 
        }
    ): Promise<AxiosResponse<{resources: {
        predictedAnnotations?: any;_id: string; confidenceScore: string; predicted: string; modelVersion: string; modelCollectionId: string
}[]}>> {
        return this.api.get(
            `${URL_STRINGS.MODEL_ANALYTICS}/resourceConfidenceScores?${queryObjectToString(reqBody)}`,
            // {
            //     cancelToken: new CancelToken(function executor(c) {
            //         cancelGetResourceConfidenceScoresApi = c
            //     })
            // }
        )        
    }

    async fetchModelCollectionHistoryData(data: {modelCollectionId: string}): Promise<ModelCollectionHistoryData>  {
        const apiResponse = await this.api.get(`${URL_STRINGS.MODEL_COLLECTION}/${data.modelCollectionId}/historyData`);
        return apiResponse.data
    }

    fetchResourceTextFileContentsFromDB(data: {
        resourceId: string,
        modelId: string,
        projectId: string,
        resourceFileName: string
    }): Promise<AxiosResponse<{text: string}>> {
        return this.api.get(`${URL_STRINGS.RESOURCE}/textFileContents?${queryObjectToString(data)}`)
    }

    getBucketListFromGCSCredentials(data: FormData): Promise<AxiosResponse<{bucketName: string}[]>> {
        return this.api.post(`cloudStorage/getListOfGCSBuckets`, data)
    }

    uploadDatafromGCS(
        data: FormData
    ): Promise<AxiosResponse<{uploadProcessId: string}>> {
        return this.api.post(`uploadDataProcesses/createUploadDataProcess`, data)

    }

    stopUploadingDatafromGCS(
        data: {
            uploadProcessId: string
        }
    ): Promise<AxiosResponse<any>> {
        return this.api.post("/uploadDataProcesses/stopUploadDataProcess", data)
    }

    getUploadProgress(
        data: {
            uploadProcessId: string
        }
    ): Promise<AxiosResponse<{
        UploadPercentageCompleted: number
      }>> {
        return this.api.get(`uploadDataProcesses/${data.uploadProcessId}/uploadPercentageCompletionStatus`)
    }
    downloadTrimmedVideo(
        data: {
            signedUrl: string,
            startTime: Number,
            endTime: Number
        }
    ): Promise<AxiosResponse<any>> {
        return this.api.post(`${URL_STRINGS.RESOURCE}/downloadTrimmedVideo`, data,
        {
            responseType: "blob", // Specify the response type as 'blob' to receive a Blob object
        })
    }
    moveTrimmedVideoToModel(
        data: any
    ): Promise<AxiosResponse<any>> {
        return this.api.post(`${URL_STRINGS.RESOURCE}/moveTrimmedVideoToModel`, data)
    }

    getTestCollectionForTrainedTestedPopup(userEmail: string): Promise<AxiosResponse<any>> {
        return this.api.get(`${URL_STRINGS.TEST_COLLECTION}/getCollectionWithUnseenTestedNotification?userEmail=${userEmail}`)
    }

    getTestCollectionForQnAPopup(userEmail: string, snoozeTime: number): Promise<AxiosResponse<any>> {
        return this.api.get(`${URL_STRINGS.TEST_COLLECTION}/getCollectionWithSeenTestedNotificationAndPendingQnA?userEmail=${userEmail}&snoozeTime=${snoozeTime}`)
    }

    getResourceCSVData(ids: string []): Promise<AxiosResponse<any>> {
        return this.api.get(`${URL_STRINGS.RESOURCE}/resourceCsvData?ids=${ids}`)
    }

    downloadResourceCSVData(ids: string []): Promise<AxiosResponse<any>> {
        return this.api.post(`${URL_STRINGS.RESOURCE}/downloadResourceCsvData?ids=${JSON.stringify(ids)}`)
    }

    removeResourcesFromDataSetCollections(requestBody: {resourceIds: string[], dataSetCollectionIds: string[]}): Promise<AxiosResponse<{
            dataSetsResult: {
              modifiedCount: number
            },
            resourcesResult: {
              modifiedCount: number
            }
    }>> {
        return this.api.put(`${URL_STRINGS.DATASET_COLLECTION}/removeResourcesFromDataSets`, requestBody)
    }

    getCollectionMetricsFromAiModelTestResultCSV(data: {
        modelCollectionId: string,
        testCollectionId?: string,
        confidenceScoreThreshold: number,
        iouThreshold?: number,
        /** pass this if calculation should happen based on this test data set, instead of default dataset */
        dataSetCollectionId?: string,
    }): Promise<AxiosResponse<collectionMetricsFromAiModelTestResultCSVApiResponse>> {
        return this.api.get(`${URL_STRINGS.MODEL_COLLECTION}/metricsFromAiModelTestResultCSV?confidenceScoreThreshold=${data.confidenceScoreThreshold}${isNullOrUndefined(data.iouThreshold) ? "" : "&iouThreshold=" + data.iouThreshold}&modelCollectionId=${data.modelCollectionId}${isNullOrUndefined(data.testCollectionId) ? "" : "&testCollectionId=" + data.testCollectionId}${isNullOrUndefined(data.dataSetCollectionId) ? "" : "&dataSetCollectionId=" + data.dataSetCollectionId}`)
    }

    getResourceMetadataFileDownloadUrl(data: {
        resourceId: string
    }): Promise<AxiosResponse<{metadataFileDownloadUrl: string}>> {
        return this.api.get(`${URL_STRINGS.RESOURCE}/metadataFileDownloadUrl?resourceId=${data.resourceId}`);
    }

    shuffleDataSetCollections(requestBody:{ modelId:string, id:string,name:string}):Promise<AxiosResponse<{
        dataSetCollectionDetails:ICollection
    }>>{
        return this.api.post(`${URL_STRINGS.DATASET_COLLECTION}/shuffleDataSetCollection`, requestBody)
    }

    splitDataSetCollectionIntoTestTrain(requestBody:{modelId:string,id:string,trainPercentage:number,testPercentage:number,isShuffled:boolean}):Promise<AxiosResponse<{
        message:string
    }>>{
        return this.api.post(`${URL_STRINGS.DATASET_COLLECTION}/splitDatasetIntoTestTrain`, requestBody)

    }

    getParsedCsvData(csvString:string): Promise<AxiosResponse<getParsedCsvStringDataAPIResponseType>> {
        return this.api.post(`${URL_STRINGS.RESOURCE}/parseCsvString`,{csvString});
    }
}

export type getParsedCsvStringDataAPIResponseType = {
    isParsingSuccess: boolean, 
    rows: { [key: string]: string }[], 
    columns: { colName: string }[]
} 


type ModelCollectionParentCheckpointFileDetailsApiResponse = {
    modelCollection: {
        version: string,
        parentCheckpointFile: {
            name: string,
            gcsName: string
        }
    }        
}

export type collectionMetricsFromAiModelTestResultCSVApiResponse = {
    F1: number;
    Precision: number;
    Recall: number;
    integrityFrequency: number;
    'Average IoU': number;
    'Mean Average Precision': number;
    Labels: {
        [label: string]: {
            F1: number;
            Precision: number;
            Recall: number;
            IntegrityAccuracy?: number;
            integrityFrequency: number;
            'Average IoU': number;
            'Mean Average Precision': number;
        };
    };
}

export default new DataService();
